import { UUIRadioButtonTheme } from '@aytm/lib/uui/types/UUIRadioButton'

const radioButtonTheme: UUIRadioButtonTheme = {
  element: ({ style = 'filled', size = 'normal', variant = 'normal' }) => {
    const disabled = 'disabled' === variant
    const invalid = 'invalid' === variant

    const baseClassName = `tw:flex tw:items-center tw:justify-center tw:select-none  tw:[&_span]:rounded-full tw:[&_span]:w-1/2 tw:[&_span]:h-1/2 ${
      'small' === size
        ? 'tw:w-3.5 tw:h-3.5  tw:[&_span]:w-1.75 tw:[&_span]:h-1.75'
        : 'tw:w-4 tw:h-4 tw:[&_span]:w-2 tw:[&_span]:h-2'
    } tw:rounded-full tw:border ${disabled ? '' : 'tw:cursor-pointer'}`

    const radioButtonClassNames = [baseClassName]

    if (disabled) {
      radioButtonClassNames.push(
        'outline' === style
          ? // disabled | outline | both checked and unchecked
            [
              'tw:border-grey-700 tw:bg-grey-800 tw:shadow-none',
              'tw:[&[data-state=checked]]:border-grey-700 tw:[&[data-state=checked]]:bg-grey-800'
            ].join(' ')
          : // disabled | filled | both checked and unchecked
            [
              'tw:border-grey-600 tw:bg-grey-600 tw:shadow-none',
              'tw:[&[data-state=checked]]:border-grey-600 tw:[&[data-state=checked]]:bg-grey-600'
            ].join(' ')
      )
      radioButtonClassNames.push(
        'outline' === style
          ? // indicator | disabled | outline
            'tw:[&_span]:bg-grey-600'
          : // indicator | disabled | filled
            'tw:[&_span]:bg-grey-700'
      )
    } else if (invalid) {
      radioButtonClassNames.push(
        'outline' === style
          ? // invalid | outline
            [
              // unchecked
              'tw:border-red-50 tw:bg-transparent tw:shadow-none',
              // checked
              'tw:[&[data-state=checked]]:border-red-50 tw:[&[data-state=checked]]:bg-transparent',
              // hover
              'tw:hover:border-red-100 tw:hover:bg-transparent',
              'tw:[&[data-state=checked]]:hover:border-red-100 tw:[&[data-state=checked]]:hover:bg-transparent',
              // focus-visible
              'tw:focus-visible:border-red-50 tw:focus-visible:bg-transparent tw:focus-visible:shadow-[0_0_0_2px_rgba(226,41,78,0.35)]',
              'tw:[&[data-state=checked]]:focus-visible:border-red-50 tw:[&[data-state=checked]]:focus-visible:bg-transparent',
              // focus-visible:hover
              'tw:focus-visible:hover:border-red-100 tw:focus-visible:hover:bg-transparent tw:focus-visible:hover:shadow-[0_0_0_2px_rgba(186,10,38,0.35)]',
              'tw:[&[data-state=checked]]:focus-visible:hover:border-red-100 tw:[&[data-state=checked]]:focus-visible:hover:bg-transparent'
            ].join(' ')
          : // invalid | filled
            [
              // unchecked
              'tw:border-red-50 tw:bg-transparent tw:shadow-none',
              // checked
              'tw:[&[data-state=checked]]:border-red-50 tw:[&[data-state=checked]]:bg-red-50',
              // hover
              'tw:hover:border-red-100 tw:hover:bg-transparent',
              'tw:[&[data-state=checked]]:hover:border-red-100 tw:[&[data-state=checked]]:hover:bg-red-100',
              // focus-visible
              'tw:focus-visible:border-red-50 tw:focus-visible:bg-transparent tw:focus-visible:shadow-[0_0_0_2px_rgba(226,41,78,0.35)]',
              'tw:[&[data-state=checked]]:focus-visible:border-red-50 tw:[&[data-state=checked]]:focus-visible:bg-red-50',
              // focus-visible:hover
              'tw:focus-visible:hover:border-red-100 tw:focus-visible:hover:bg-transparent tw:focus-visible:hover:shadow-[0_0_0_2px_rgba(186,10,38,0.35)]',
              'tw:[&[data-state=checked]]:focus-visible:hover:border-red-100 tw:[&[data-state=checked]]:focus-visible:hover:bg-red-100'
            ].join(' ')
      )
      radioButtonClassNames.push(
        'outline' === style
          ? [
              // invalid | indicator | outline
              'tw:[&_span]:bg-red-50',
              // invalid | indicator | hover | outline
              'tw:hover:[&_span]:bg-red-100',
              // invalid | indicator | focus-visible | outline
              'tw:focus-visible:[&_span]:bg-red-50',
              // invalid | indicator | focus-visible:hover | outline
              'tw:focus-visible:hover:[&_span]:bg-red-100'
            ].join(' ')
          : // invalid | indicator | filled
            'tw:[&_span]:bg-grey-1000'
      )
    } else {
      radioButtonClassNames.push(
        'outline' === style
          ? // normal | outline
            [
              // unchecked
              'tw:border-grey-500 tw:bg-transparent tw:shadow-none',
              // checked
              'tw:[&[data-state=checked]]:border-blue-100 tw:[&[data-state=checked]]:bg-transparent',
              // hover
              'tw:hover:border-aquamarine-400 tw:hover:bg-transparent',
              'tw:[&[data-state=checked]]:hover:border-aquamarine-400 tw:[&[data-state=checked]]:hover:bg-transparent',
              // focus-visible
              'tw:focus-visible:border-blue-100 tw:focus-visible:bg-transparent tw:focus-visible:shadow-[0_0_0_2px_rgba(41,171,226,0.35)]',
              'tw:[&[data-state=checked]]:focus-visible:border-blue-100 tw:[&[data-state=checked]]:focus-visible:bg-transparent',
              // focus-visible:hover
              'tw:focus-visible:hover:border-aquamarine-400 tw:focus-visible:hover:bg-transparent tw:focus-visible:hover:shadow-[0_0_0_2px_rgba(91,191,192,0.35)]',
              'tw:[&[data-state=checked]]:focus-visible:hover:border-aquamarine-400 tw:[&[data-state=checked]]:focus-visible:hover:bg-transparent'
            ].join(' ')
          : // normal | filled
            [
              // unchecked
              'tw:border-grey-500 tw:bg-transparent tw:shadow-none',
              // checked
              'tw:[&[data-state=checked]]:border-blue-100 tw:[&[data-state=checked]]:bg-blue-100',
              // hover
              'tw:hover:border-aquamarine-400 tw:hover:bg-transparent',
              'tw:[&[data-state=checked]]:hover:border-aquamarine-400 tw:[&[data-state=checked]]:hover:bg-aquamarine-400',
              // focus-visible
              'tw:focus-visible:border-blue-100 tw:focus-visible:bg-transparent tw:focus-visible:shadow-[0_0_0_2px_rgba(41,171,226,0.35)]',
              'tw:[&[data-state=checked]]:focus-visible:border-blue-100 tw:[&[data-state=checked]]:focus-visible:bg-blue-100',
              // focus-visible:hover
              'tw:focus-visible:hover:border-aquamarine-400 tw:focus-visible:hover:bg-transparent tw:focus-visible:hover:shadow-[0_0_0_2px_rgba(91,191,192,0.35)]',
              'tw:[&[data-state=checked]]:focus-visible:hover:border-aquamarine-400 tw:[&[data-state=checked]]:focus-visible:hover:bg-aquamarine-400'
            ].join(' ')
      )
      radioButtonClassNames.push(
        'outline' === style
          ? [
              // indicator | outline
              'tw:[&_span]:bg-blue-100',
              // indicator | hover | outline
              'tw:hover:[&_span]:bg-aquamarine-200',
              // indicator | focus-visible | outline
              'tw:focus-visible:[&_span]:bg-blue-100',
              // indicator | focus-visible:hover | outline
              'tw:focus-visible:hover:[&_span]:bg-aquamarine-200'
            ].join(' ')
          : // indicator | filled
            'tw:[&_span]:bg-grey-1000'
      )
    }
    return radioButtonClassNames.join(' ')
  },

  label: ({ size = 'normal' }) =>
    'small' === size
      ? 'tw:flex-1 tw:text-xs tw:font-ubuntu tw:leading-[14px] tw:ml-1'
      : 'tw:flex-1 tw:text-sm tw:font-ubuntu tw:leading-4 tw:ml-2',

  indicator: () => 'tw:flex tw:items-center tw:justify-center tw:w-full tw:h-full',

  group: ({ orientation = 'vertical', disabled }) => {
    const baseClassName = `tw:inline-flex ${disabled ? '' : 'tw:cursor-pointer'}`
    const orientationClassName = 'horizontal' === orientation ? 'tw:flex-row tw:gap-4' : 'tw:flex-col tw:gap-2'
    return [baseClassName, orientationClassName].join(' ')
  }
}

export default radioButtonTheme
